import React, { ReactElement } from "react";

import clsx from "clsx";

export default function SubHeader({ children }: React.PropsWithChildren) {
  return (
    <div
      className={clsx(
        "flex w-full bg-neutral-10 gap-40 !z-[9] pr-4 py-2 items-start shadow-sm shadow-neutral-35",
        (children as ReactElement[])?.length > 1
          ? "justify-between"
          : "justify-end"
      )}
    >
      {children}
    </div>
  );
}
